import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ViewColumnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"view_column"}/>
}
